import React from 'react'
import OutlinedInput from '@material-ui/core/OutlinedInput'
import InputAdornment from '@material-ui/core/InputAdornment'
import ClearIcon from 'components/material-symbol/icons/Clear'
import SearchIcon from 'components/material-symbol/icons/Search'

export default ({
  searchTerm,
  setSearchTerm,
  placeholder,
  style = null,
  fullWidth = false,
  ...props
}) => (
  <OutlinedInput
    fullWidth={fullWidth}
    value={searchTerm}
    onChange={e => setSearchTerm(e.target.value)}
    placeholder={placeholder}
    style={style || (fullWidth ? undefined : { margin: '20px', width: '65%' })}
    startAdornment={
      <InputAdornment position="start">
        <SearchIcon />
      </InputAdornment>
    }
    endAdornment={
      searchTerm.length ? (
        <InputAdornment
          onClick={() => setSearchTerm('')}
          position="end"
          style={{ cursor: 'pointer' }}
        >
          <ClearIcon />
        </InputAdornment>
      ) : null
    }
    {...props}
  />
)
